/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider, Typography, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import OutlineButton from '../../MUICustomButton/OutlineButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { UPDATE_CLIENT_ACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1, UPDATE_ESP_DEACTIVATE_SUBTITLE_2 } from 'src/constants/constant';
import GradientButton from '../../MUICustomButton/GradientButton';
import type { ESPStatusObj, RootState } from '../../types/types';
import { getESPConnectionDataById, activatedeactivateESP } from 'src/services/emailAPIESPServices';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import EditESPForm from './EditESPForm';
import { checkEventPermission } from 'src/common/utility/utility';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


export interface PropsType {
    espId?: string;
    espData?: any;
}

function ClientDetailsPage({ espId, espData }: PropsType): JSX.Element {

    const [showDeactivateClientModal, setShowDeactivateclientModal] = useState<boolean>(false)
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [espConnectionData, setSelectedESPData] = useState<any>()

    const [showThroughputInformationForm, setShowThroughputInformationForm] = useState<boolean>(false)
    const [showESPConfiguratonForm, setESPConfigurationForm] = useState<boolean>(false)
    const [showWarmupInformationForm, setShowWarmupInformationForm] = useState<boolean>(false)
    const [showAPIInformationForm, setShowAPIInformationForm] = useState<boolean>(false)

    const { user } = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        getESPDetails()
    }, [espId, espData])

    const getESPDetails = (): void => {
        setIsDataLoading(true)
        if (espId) {
            getESPConnectionDataById(espId).then(
                (res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            setSelectedESPData(res.data.data[0])
                        }

                    }
                }
            )
            .catch(
                error => console.log("Error: ", error)
            )
            .finally(() => {
                setIsDataLoading(false)
            })
        }
    }

    const handleEditThroughputClick = (): void => {
        setShowThroughputInformationForm(true)
        setESPConfigurationForm(false)
        setShowWarmupInformationForm(false)
        setShowAPIInformationForm(false)
    }

    const handleEditESPClick = (): void => {
        setESPConfigurationForm(true)
        setShowThroughputInformationForm(false)
        setShowWarmupInformationForm(false)
        setShowAPIInformationForm(false)
    }

    const handleEditWarmupClick = (): void => {
        setShowWarmupInformationForm(true)
        setShowThroughputInformationForm(false)
        setESPConfigurationForm(false)
        setShowAPIInformationForm(false)
    }

    const handleEditAPIClick = (): void => {
        setShowWarmupInformationForm(false)
        setShowThroughputInformationForm(false)
        setESPConfigurationForm(false)
        setShowAPIInformationForm(true)
    }

    const handleStatusChange = (): void => {
        setShowDeactivateclientModal(true)
    }

    const handleDeactivateClientClose = (): void => {
        setShowDeactivateclientModal(false)
    }

    const handleCancelClick = (): void => {
        setShowWarmupInformationForm(false)
        setShowThroughputInformationForm(false)
        setESPConfigurationForm(false)
        setShowAPIInformationForm(false)
        getESPDetails()
    }

    const handleDeactivateClientConfirm = async (): Promise<void> => {
        setIsModalSaveLoading(true)
        const data: ESPStatusObj = {
            "modifiedBy": user?.id,
            "isActive": espData?.isActive === true ? false : true,
            "espConnectionLst": [
                {
                    "id": espData?.id
                }
            ]
        }
        try {
            const res = await activatedeactivateESP(data);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success(
                        ((espData?.isActive) === true)
                            ? "ESP deactivated successfully"
                            : "ESP activated successfully"
                    );
                    espData.isActive = espData?.isActive === true ? false : true
                    //   getClientData();
                }
            }
        } catch (error) {
            console.error("Error activating/deactivating ESP:", error);
            NotificationManager.error("An error occurred. Please try again.");
        } finally {
            setShowDeactivateclientModal(false);
            setIsModalSaveLoading(false);
        }
    }
    return (
        <React.Fragment>
            <div className="flex justify-between items-center mb-[20px]">
                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
                    ESP Settings
                </Typography>
            {checkEventPermission("ESP_ACTIVATE") &&
                <OutlineButton onClick={handleStatusChange} type='rounded' color='red' width='130px'>
                    {espData.isActive ? 'Deactivate' : 'Activate'}
                </OutlineButton>
            }
            </div>
            <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
            {
                isDataLoading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                    <React.Fragment>
                        <div className='form-sub-container'>
                            <div className='flex justify-between items-center'>
                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                                    ESP Configuration
                                </Typography>
                                {
                                    (showESPConfiguratonForm === false && checkEventPermission("ESP_UPDATE") ) &&
                                    <OutlineButton color='gray' onClick={() => handleEditESPClick()} width='80px'>
                                        <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                                    </OutlineButton>
                                }
                            </div>

                            {
                                showESPConfiguratonForm === true ?
                                    <EditESPForm espId={espId} espData={espConnectionData} step="1" onCancel={handleCancelClick} /> :
                                    <React.Fragment>

                                        <div className='grid gap-5 grid-cols-2'>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    Connection Name
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.connectionName}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className='grid gap-5 grid-cols-2'>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                   Email Service Provider
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.connectionTypeId === 1 ? "Mailgun" : espConnectionData?.connectionTypeId === 2 ? "Sendgrid" : ""}
                                                </Typography>
                                            </div>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    Domain Name
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.domain}
                                                </Typography>
                                            </div>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    From Name
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.fromName}
                                                </Typography>
                                            </div>
                                            <div className='w-full relative'>
                                                <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                    From Email
                                                </Typography>
                                                <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                    {espConnectionData?.fromEmail}
                                                </Typography>
                                            </div>
                                        </div>
                                    </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
            }

<div className='form-sub-container'>
                <div className='flex justify-between items-center'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        API Information
                    </Typography>
                    {
                        (showAPIInformationForm === false  && checkEventPermission("ESP_UPDATE") ) &&
                        <OutlineButton color='gray' onClick={() => handleEditAPIClick()} width='80px'>
                            <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                        </OutlineButton>
                    }
                </div>
                {
                    <React.Fragment>
                        {
                            showAPIInformationForm === true ?
                                <EditESPForm espId={espId} espData={espConnectionData} step="4" onCancel={handleCancelClick} /> :

                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                ESP Account Key
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.espAccountKey}
                                            </Typography>
                                        </div>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                ASM GroupId
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.asmGroupId}
                                            </Typography>
                                        </div>
                                    </div>
                                </React.Fragment>
                        }
                    </React.Fragment>
                }

            </div>
            
            <div className='form-sub-container'>
                <div className='flex justify-between items-center'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Throughput Information
                    </Typography>
                    {
                        (showThroughputInformationForm === false && checkEventPermission("ESP_UPDATE") ) &&
                        <OutlineButton color='gray' onClick={() => handleEditThroughputClick()} width='80px'>
                            <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                        </OutlineButton>
                    }
                </div>
                {
                    <React.Fragment>
                        {
                            showThroughputInformationForm === true ?
                                <EditESPForm espId={espId} espData={espConnectionData} step="2" onCancel={handleCancelClick} /> :

                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Daily Limit
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.dailyCount}
                                            </Typography>
                                        </div>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Hourly Limit
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.hourlyCount}
                                            </Typography>
                                        </div>
                                    </div>
                                </React.Fragment>
                        }
                    </React.Fragment>
                }

            </div>
            <div className='form-sub-container'>
                <div className='flex justify-between items-center'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Warmup Information
                    </Typography>
                    {
                        (showWarmupInformationForm === false && checkEventPermission("ESP_UPDATE") ) &&
                        <OutlineButton color='gray' onClick={() => handleEditWarmupClick()} width='80px'>
                            <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" style={{ marginRight: '10px' }} /> Edit
                        </OutlineButton>
                    }
                </div>
                {
                    <React.Fragment>
                        {
                            showWarmupInformationForm === true ?
                                <EditESPForm espId={espId} espData={espConnectionData} step="3" onCancel={handleCancelClick} /> :

                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Warmup
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.hasWarmup === true ? "Yes" : espConnectionData?.hasWarmup === false ? "No" : ""}
                                            </Typography>
                                        </div>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Warmup Multiplier
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.warmupMultiplier}
                                            </Typography>
                                        </div>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Warmup Tracking Days
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.warmupTrackingDays}
                                            </Typography>
                                        </div>
                                        <div className='w-full relative'>
                                            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
                                                Warmup Start Count
                                            </Typography>
                                            <Typography sx={{ color: '#3A3A3A', fontSize: '14px', marginBottom: '20px' }}>
                                                {espConnectionData?.warmupStartCount}
                                            </Typography>
                                        </div>
                                    </div>
                                </React.Fragment>
                        }
                    </React.Fragment>
                }

            </div>
            <BootstrapDialog
                onClose={handleDeactivateClientClose}
                aria-labelledby="customized-dialog-title"
                open={showDeactivateClientModal}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    {espData && espData.isActive === true ? "Deactivate ESP" : "Activate ESP"}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleDeactivateClientClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <HugeiconsIcon
                     icon={MultiplicationSignStrokeStandard}
                     size={24}
                     color="currentcolor"
                     strokeWidth={0.5}
                                                     /> 
                </IconButton>
                <DialogContent>
                    {
                        espData !== undefined && espData.isActive === true ?
                            <p className='text-14 text-muted'>{UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${espConnectionData !== undefined ? espConnectionData.connectionName : ''} `}</span> {UPDATE_ESP_DEACTIVATE_SUBTITLE_2}</p>
                            :
                            <p className='text-14 text-muted'>{UPDATE_CLIENT_ACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${espConnectionData !== undefined ? espConnectionData.connectionName : ''}`}</span> {UPDATE_ESP_DEACTIVATE_SUBTITLE_2}</p>
                    }

                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleDeactivateClientClose} width='130px'>Cancel</OutlineButton>
                    {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
                    <GradientButton color='red' onClick={() => {
                        void handleDeactivateClientConfirm();
                    }} width='130px'>{
                            isModalSaveLoading ? (
                                <span className="loading loading-spinner loading-xs text-white"></span>
                            ) : ((espData?.isActive) === true) ? "Deactivate" : "Activate"
                        }</GradientButton>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ClientDetailsPage